import { apiGet } from './client';
import type { Lending, LendingAccount, LendingBank, LendingFeeBreakdown } from '../types/Lending';

// bankId omitted → every bank. The filter is applied SERVER-SIDE: a tenant can
// hold tens of thousands of open lendings, so narrowing by bank is the screen's
// main lever and must not be a client-side filter over a full download.
export function getLendings(bankId?: number, acc?: number): Promise<Lending[]> {
  const p = new URLSearchParams();
  if (bankId) p.set('bankId', String(bankId));
  if (acc) p.set('acc', String(acc));
  const q = p.toString();
  return apiGet<Lending[]>(`/api/lendings${q ? `?${q}` : ''}`);
}

// Accounts at one bank that hold lendings (feeds the account combo).
export function getLendingAccounts(bankId: number): Promise<LendingAccount[]> {
  return apiGet<LendingAccount[]>(`/api/lendings/accounts?bankId=${bankId}`);
}

// The banks this tenant actually HOLDS lendings at, largest first — not the
// Central catalog of every Israeli bank, which would offer ~20 options when four
// have anything to show and make the screen's default an arbitrary pick.
export function getLendingBanks(): Promise<LendingBank[]> {
  return apiGet<LendingBank[]>('/api/lendings/banks');
}

// Drill-down for one lending: its Lendings_view row plus the component rows of its
// fee, straight from dbo.LendingFeeBreakdown (the single implementation of the formula).
export function getLendingFeeBreakdown(lendingId: number): Promise<LendingFeeBreakdown> {
  return apiGet<LendingFeeBreakdown>(`/api/lendings/${lendingId}/fee-breakdown`);
}
